import React, { Component } from 'react';
import classnames from 'classnames';
import { CircularProgress, Box } from '@mui/material';

export default class Spinner extends Component {
  static propTypes = {};

  render() {
    const { message, className, style = {}, size = 40, color, ...rest } = this.props;
    const customSize = style.height ? style.height : null;
    
    // Function to convert CSS size values to pixels for CircularProgress size prop
    const convertSizeToPixels = (cssSize) => {
      if (!cssSize) return size;
      
      // If it's already a number, return it
      if (typeof cssSize === 'number') return cssSize;
      
      // If it's a string, parse it
      if (typeof cssSize === 'string') {
        const match = cssSize.match(/^(\d+(?:\.\d+)?)(px|rem|em|%)?$/);
        if (match) {
          const value = parseFloat(match[1]);
          const unit = match[2] || 'px';
          
          switch (unit) {
            case 'px':
              return value;
            case 'rem':
              // Convert rem to px (assuming 1rem = 16px)
              return value * 16;
            case 'em':
              // Convert em to px (assuming 1em = 16px)
              return value * 16;
            case '%':
              // For percentage, use the default size as base
              return (value / 100) * size;
            default:
              return value;
          }
        }
      }
      
      return size;
    };

    const spinnerSize = convertSizeToPixels(customSize);
    
    return (
      <div 
        {...rest} 
        className={classnames(className, 'common-spinner')}
        style={{
          ...style,
          height: customSize || style.height,
          width: customSize || style.width
        }}
      >
        <Box 
          display="flex" 
          flexDirection="column" 
          alignItems="center" 
          gap={2}
          sx={{
            height: customSize ? customSize : 'auto',
            justifyContent: 'center'
          }}
        >
          <CircularProgress 
            size={spinnerSize}
            sx={color ? { 
              color: color,
              '& .MuiCircularProgress-svg': {
                color: color,
              },
              '& .MuiCircularProgress-circle': {
                stroke: color,
              }
            } : {
              color: '#4567e5',
              '& .MuiCircularProgress-svg': {
                color: '#4567e5',
              },
              '& .MuiCircularProgress-circle': {
                stroke: '#4567e5',
              }
            }}
          />
          {message && <span>{message}</span>}
        </Box>
      </div>
    );
  }
}
